/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * The gym-grant fields of the own-Users document, reduced to the shape the
 * client watches for a role change. Leaf module: no firebase import, so tests
 * can inject a raw snapshot at this exact seam.
 */

/**
 * Reads the raw Users snapshot, never the Redux userInfoData copy: the
 * snapshot arrives before the extra getDoc that refills userInfoData, and a
 * refresh gated on the slower of the two would report a role change late.
 *
 * @param {Object} [data] Users document data, or undefined when it is missing.
 * @return {{boxID: (string|null), boxRole: (string|null), boxStatus: (string|null),
 *   boxGrantVersion: (number|null), claimsStale: boolean, boxLicensed: boolean}} The watched fields.
 */
export const grantSignalFromUserDoc = (data) => ({
  boxID: data?.boxID ?? null,
  boxRole: data?.boxRole ?? null,
  boxStatus: data?.boxStatus ?? null,
  // A string version would compare unequal to its own number on every snapshot
  // and drive a refresh loop, so anything but a number is treated as absent.
  boxGrantVersion: typeof data?.boxGrantVersion === "number" ? data.boxGrantVersion : null,
  claimsStale: data?.claimsStale === true,
  // The gym licence lands on the Users doc first; the token follows on refresh.
  boxLicensed: data?.boxLicense != null,
});

/**
 * @param {Object} [a] A grant signal, or null.
 * @param {Object} [b] A grant signal, or null.
 * @return {boolean} Whether both describe the same grant.
 */
export const grantSignalEquals = (a, b) => {
  if (a === b) return true;
  if (!a || !b) return false;
  return (
    a.boxID === b.boxID &&
    a.boxRole === b.boxRole &&
    a.boxStatus === b.boxStatus &&
    a.boxGrantVersion === b.boxGrantVersion &&
    a.claimsStale === b.claimsStale &&
    a.boxLicensed === b.boxLicensed
  );
};
